/* eslint-disable */

export const trackFacebookConversion = (name, properties) => {
  if (window) {
    if (window.fbq) {
      window.fbq(`track`, name, properties);
    }
  }
};
